module.exports = __webpack_public_path__ + "static/media/HiTom808.3b19b79c.wav";